<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 32,
      height: 32,
      color: 'currentColor',
      viewBoxValue: `0 0 33 32`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <g id="message-chat-circle">
      <path
        id="Icon"
        d="M8.92839 14.9717C8.84552 14.4376 8.80252 13.8905 8.80252 13.3333C8.80252 7.44229 13.6096 2.66666 19.5394 2.66666C25.4692 2.66666 30.2762 7.44229 30.2762 13.3333C30.2762 14.6641 30.0309 15.9379 29.5828 17.1127C29.4897 17.3566 29.4432 17.4786 29.422 17.5739C29.4011 17.6682 29.393 17.7346 29.3907 17.8313C29.3884 17.9288 29.4017 18.0362 29.4281 18.2511L29.9649 22.6114C30.023 23.0834 30.0521 23.3194 29.9735 23.491C29.9048 23.6413 29.7826 23.7607 29.6307 23.826C29.4573 23.9005 29.2221 23.8661 28.7515 23.7971L24.5045 23.1745C24.2828 23.142 24.1719 23.1258 24.0709 23.1264C23.971 23.1269 23.9019 23.1343 23.8041 23.1549C23.7053 23.1756 23.579 23.2229 23.3265 23.3175C22.1488 23.7586 20.8725 24 19.5394 24C18.9818 24 18.4341 23.9578 17.8995 23.8764M10.978 29.3333C14.9312 29.3333 18.1359 26.0501 18.1359 22C18.1359 17.9499 14.9312 14.6667 10.978 14.6667C7.02481 14.6667 3.82012 17.9499 3.82012 22C3.82012 22.8141 3.94961 23.5973 4.18864 24.329C4.28968 24.6383 4.3402 24.7929 4.35678 24.8986C4.37409 25.0089 4.37712 25.0708 4.37068 25.1823C4.3645 25.2891 4.33779 25.4097 4.28436 25.6511L3.46924 29.3333L7.46231 28.788C7.68026 28.7582 7.78923 28.7433 7.8844 28.744C7.9846 28.7447 8.03778 28.7501 8.13605 28.7697C8.22938 28.7883 8.36812 28.8373 8.6456 28.9352C9.37669 29.1932 10.1614 29.3333 10.978 29.3333Z"
        stroke="#667085"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </IconBase>
</template>

<style scoped lang="scss"></style>
